import { backendApi } from "./backendApi.rtkq";

export interface GlobalUsageStats {
  totalCredits: number;
  totalOps: number;
  dailyStats: {
    date: string;
    credits: number;
    ops: number;
  }[];
  topApps: {
    appId: string;
    credits: number;
    ops: number;
  }[];
  topAccounts: {
    accountId: string;
    accountName: string;
    credits: number;
    ops: number;
  }[];
}

export interface GetGlobalUsageStatsResponse {
  success: boolean;
  data?: GlobalUsageStats;
  message?: string;
}

export const analyticsApi = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    getGlobalUsageStats: builder.query<GlobalUsageStats | undefined, { days?: number }>({
      query: ({ days = 30 }) => ({
        url: "/admin/usage-stats",
        params: { days },
      }),
      transformResponse: (response: any) => {
        // Backend may wrap in { success, data } or return directly
        return response.data || response;
      },
      providesTags: ["Usage"],
    }),
  }),
});

export const { useGetGlobalUsageStatsQuery } = analyticsApi;
